import _ from "@lodash";
import { Avatar, Chip, Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@material-ui/core";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaTagNewButton from "app/ERP/EmpresaTag/EmpresaTagNewButton";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import { MdAdd, MdLabel } from "react-icons/md";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/FuncionalidadeTagActions";
import FuncionalidadeTagReducer from "./Store/Reducers/FuncionalidadeTagReducer";


class FuncionalidadeTagApp extends XAPPComponent {

    state = {
        form: [],
        tagMenuEl: null
    };

    componentDidMount() {
        const { list, FuncionalidadeTag, target, xappRouteParams, campoid, foreingkey } = this.props;
        if (_.isUndefined(FuncionalidadeTag[target])) {
            list("SELECIONAR", xappRouteParams, target, campoid, foreingkey);
        }
    }

    componentDidUpdate() {
        if (this.props.FuncionalidadeTag.error) {
            this.props.showMessage({
                message: this.props.FuncionalidadeTag.error,
                variant: "error"
            });
            this.props.FuncionalidadeTag.error = null;
        }
    }

    componentWillUnmount() {
        this.props.clearReducer();
    }

    handleTagMenuOpen = (event) => {
        this.setState({ tagMenuEl: event.currentTarget });
    };

    handleTagMenuClose = () => {
        this.setState({ tagMenuEl: null });
    };

    handleChangeTag = (_AValue) => {
        if (this.isSelected(_AValue)) {
            this.props.RemoveTag(_AValue, this.props.xappRouteParams, this.props.target, this.props.campoid, this.props.foreingkey);
        }
        else {
            this.props.SetTag(_AValue, this.props.xappRouteParams, this.props.target, this.props.campoid, this.props.foreingkey);
        }
    };

    isSelected = (_AValue) => {
        var { FuncionalidadeTag, target } = this.props;
        var AExists = false;
        FuncionalidadeTag[target] && FuncionalidadeTag[target].forEach((item) => {
            if (item.codigo === _AValue.codigo) {
                AExists = true;
            }
        });
        return AExists;
    };

    render() {

        const { tagMenuEl } = this.state;
        const { target, tags, tipo, className, readOnly, xappRouteParams, FuncionalidadeTag, refreshTags = null, foreingkey } = this.props;
        return (
            <CatchErro
                url={this.props.match.url}
            >
                {!_.isNull(foreingkey) &&
                    <div className="flex w-full">
                        <IconButton
                            className={className}
                            aria-owns={tagMenuEl ? "label-menu" : null}
                            aria-haspopup="true"
                            style={{ maxHeight: "10" }}
                            disabled={readOnly}
                            onClick={this.handleTagMenuOpen}
                        >
                            <MdLabel />
                        </IconButton>
                        <Menu
                            id="label-menu"
                            anchorEl={tagMenuEl}
                            open={Boolean(tagMenuEl)}
                            onClose={this.handleTagMenuClose}
                        >
                            {!_.isUndefined(tags) && !_.isNull(tags) && tags.map((tag) => (
                                <MenuItem
                                    onClick={() => { this.handleChangeTag(tag); }}
                                    key={"MenuItem_" + tag.codigo}
                                >
                                    <ListItemIcon>
                                        <Icon className="mr-0" color="action">
                                            {this.isSelected(tag) ? "check_box" : "check_box_outline_blank"}
                                        </Icon>
                                    </ListItemIcon>
                                    <ListItemIcon>
                                        <MdLabel className="mr-0" style={{ color: tag.cor }} color="action" />
                                    </ListItemIcon>
                                    <ListItemText primary={tag.tagnome} disableTypography={true} />
                                </MenuItem>
                            ))}
                            {!_.isNull(refreshTags) &&
                                <EmpresaTagNewButton
                                    xappRouteParams={xappRouteParams}
                                    tipo={tipo}
                                    callback={() => {
                                        refreshTags();
                                        this.handleTagMenuClose();
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => { }}
                                        key={"MenuItem_NovaTag"}
                                    >
                                        <ListItemIcon>
                                            <MdAdd className="mr-0 text-20" color="action" />
                                        </ListItemIcon>
                                        <ListItemText primary={"Adicionar tag"} disableTypography={true} />
                                    </MenuItem>
                                </EmpresaTagNewButton>
                            }
                        </Menu>

                        {FuncionalidadeTag[target] && FuncionalidadeTag[target] !== null && (
                            <div className={clsx("flex flex-wrap", className)}>
                                {FuncionalidadeTag[target].map(tag => {
                                    var ATag = {};
                                    ATag = _.find(tags, { codigo: tag.codigo });
                                    if (!_.isUndefined(ATag)) {
                                        if (!readOnly) {
                                            return (
                                                <Chip
                                                    avatar={(
                                                        <Avatar
                                                            classes={{ colorDefault: "bg-transparent" }}>
                                                            <MdLabel
                                                                className="text-20"
                                                                style={{ color: ATag ? ATag.cor : "" }}
                                                            />
                                                        </Avatar>
                                                    )}
                                                    label={ATag ? ATag.tagnome : ""}
                                                    onDelete={() => this.props.RemoveTag(ATag, this.props.xappRouteParams, this.props.target, this.props.campoid, this.props.foreingkey)}
                                                    className="mr-8 my-8"
                                                    classes={{ label: "pl-4" }}
                                                    key={"ChipTag_" + ATag.codigo}
                                                />
                                            );
                                        }
                                        else {
                                            return (
                                                <Chip
                                                    avatar={(
                                                        <Avatar
                                                            classes={{ colorDefault: "bg-transparent" }}>
                                                            <MdLabel
                                                                className="text-20"
                                                                style={{ color: ATag.cor }}
                                                            />
                                                        </Avatar>
                                                    )}
                                                    label={ATag.tagnome}
                                                    className="mr-8 my-8"
                                                    classes={{ label: "pl-4" }}
                                                    key={"ChipTag_" + ATag.codigo}
                                                />
                                            );
                                        }
                                    }
                                })}
                            </div>
                        )}
                    </div>
                }
            </CatchErro>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        SetTag: Actions.SetTag,
        RemoveTag: Actions.RemoveTag,
        clearReducer: Actions.clearReducer,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage
    }, dispatch);
}

function mapStateToProps({ FuncionalidadeTagApp }) {
    return {
        FuncionalidadeTag: FuncionalidadeTagApp,

    };
}

export default withReducer("FuncionalidadeTagApp", FuncionalidadeTagReducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(FuncionalidadeTagApp)));
